/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import TektelicMissingTranslateHandler from './translate-handler';

export default angular.module('tektelic.locale', [])
    .factory('tkMissingTranslationHandler', TektelicMissingTranslateHandler)
    .constant('locales',
        {
            'en_US': {
                "access": {
                    "unauthorized": "Unauthorized",
                    "unauthorized-access": "Unauthorized Access",
                    "unauthorized-access-text": "You should sign in to have access to this resource!",
                    "access-forbidden": "Access Forbidden",
                    "access-forbidden-text": "You haven't access rights to this location!<br/>Try to sign in with different user if you still wish to gain access to this location.",
                    "refresh-token-expired": "Session has expired",
                    "refresh-token-failed": "Unable to refresh session"
                },
                "action": {
                    "activate": "Activate",
                    "suspend": "Suspend",
                    "save": "Save",
                    "saveAs": "Save as",
                    "cancel": "Cancel",
                    "ok": "OK",
                    "delete": "Delete",
                    "add": "Add",
                    "yes": "Yes",
                    "no": "No",
                    "update": "Update",
                    "remove": "Remove",
                    "search": "Search",
                    "assign": "Assign",
                    "unassign": "Unassign",
                    "move": "Move",
                    "share": "Share",
                    "make-private": "Make private",
                    "apply": "Apply",
                    "apply-changes": "Apply changes",
                    "edit-mode": "Edit mode",
                    "enter-edit-mode": "Enter edit mode",
                    "decline-changes": "Decline changes",
                    "close": "Close",
                    "back": "Back",
                    "run": "Run",
                    "sign-in": "Sign in!",
                    "edit": "Edit",
                    "view": "View",
                    "create": "Create",
                    "drag": "Drag",
                    "refresh": "Refresh",
                    "undo": "Undo",
                    "copy": "Copy",
                    "paste": "Paste",
                    "copy-reference": "Copy reference",
                    "paste-reference": "Paste reference",
                    "import": "Import",
                    "export": "Export",
                    "share-via": "Share via {{provider}}"
                },
                "admin": {
                    "general": "General",
                    "general-settings": "General Settings",
                    "outgoing-mail": "Outgoing Mail",
                    "outgoing-mail-settings": "Outgoing Mail Settings",
                    "sms": "SMS",
                    "sms-settings": "SMS settings",
                    "system-settings": "System Settings",
                    "test-mail-sent": "Test mail was successfully sent!",
                    "test-sms-sent": "Test SMS was successfully sent!",
                    "base-url": "Base URL",
                    "base-url-required": "Base URL is required.",
                    "mail-from": "Mail From",
                    "mail-from-required": "Mail From is required.",
                    "smtp-protocol": "SMTP protocol",
                    "smtp-host": "SMTP host",
                    "smtp-host-required": "SMTP host is required.",
                    "smtp-port": "SMTP port",
                    "smtp-port-required": "You must supply a smtp port.",
                    "smtp-port-invalid": "That doesn't look like a valid smtp port.",
                    "timeout-msec": "Timeout (msec)",
                    "timeout-required": "Timeout is required.",
                    "timeout-invalid": "That doesn't look like a valid timeout.",
                    "enable-tls": "Enable TLS",
                    "send-test-mail": "Send test mail",
                    "send-test-sms": "Send test SMS",
                    "sms-provider": "SMS Provider",
                    "sms-twilio": "Twilio",
                    "sms-account-sid": "Account sid",
                    "sms-account-sid-required": "Account sid is required.",
                    "sms-auth-token": "Auth token",
                    "sms-auth-token-required": "Auth token is required.",
                    "sms-service-sid": "Messaging service sid",
                    "sms-service-sid-required": "Messaging service sid is required.",
                    "ns-version": "Network Server S/W v.{{version}}",
                    "test-sms-to": "Phone number",
                    "test-sms-body": "Message body",
                },
                "aggregation": {
                    "aggregation": "Aggregation",
                    "function": "Data aggregation function",
                    "limit": "Max values",
                    "group-interval": "Grouping interval",
                    "min": "Min",
                    "max": "Max",
                    "avg": "Average",
                    "sum": "Sum",
                    "count": "Count",
                    "none": "None"
                },
                "api-limits": {
                    "api-limits": "Api limits",
                    "enabled": "Enabled",
                    "time-unit": "Time unit",
                    "time-unit-required": "Time unit is required.",
                    "time-value": "Time value",
                    "time-value-required": "Time value is required.",
                    "max-packets": "Max number of packets",
                    "max-packets-required": "Max number of packets is required.",
                    "time-unit-hours": "Hours",
                    "time-unit-days": "Days"
                },
                "alarm": {
                    "alarms": "Alarms",
                    "browse-alarms": "Browse alarms"
                },
                "alarm-rule": {
                    "alarm-rule": "Alarm Rule",
                    "alarm-rules": "Alarm Rules",
                    "add-alarm-rule": "Add Alarm Rule",
                    "edit-alarm-rule": "Edit Alarm Rule",
                    "view-alarm-rule": "View Alarm Rule",
                    "delete-alarm-rule": "Delete Alarm Rule",
                    "delete-alarm-rule-title": "Are you sure you want to delete the Alarm Rule '{{alarmRuleName}}'?",
                    "delete-alarm-rule-text": "Be careful, after the confirmation the Alarm Rule will be removed.",
                    "delete-alarm-rules": "Delete Alarm Rules",
                    "delete-alarm-rules-title": "Are you sure you want to delete { count, plural, 1 {1 Alarm Rule} other {# Alarm Rules} }?",
                    "delete-alarm-rules-text": "Be careful, after the confirmation all selected Alarm Rules will be removed.",
                    "name": "Name",
                    "name-required": "Name is required",
                    "description": "Description",
                    "description-required": "Description is required",
                    "no-alarm-rules-prompt": "No Alarm Rules found",
                    "selected-alarm-rules": "{ count, plural, 1 {1 Alarm Rule} other {# Alarm Rules} } selected",
                    "alarm-triggers": "Alarm triggers",
                    "trigger-type": "Type",
                    "add-alarm-trigger": "Add alarm trigger",
                    "no-alarm-triggers-prompt": "No alarm triggers configured",
                    "trigger-gw-offline": "Gateway is offline",
                    "trigger-gw-online": "Gateway is online",
                    "trigger-gw-alarm": "Gateway alarm",
                    "trigger-gw-fault": "Gateway fault",
                    "trigger-gw-event": "Gateway event",
                    "trigger-dev-offline": "Device is offline",
                    "trigger-dev-online": "Device is online",
                    "trigger-integration-connected": "Integration is connected",
                    "trigger-integration-disconnected": "Integration is disconnected",
                    "delete-alarm-trigger": "Delete alarm trigger",
                    "notifications": "Notifications",
                    "notification-type": "Type",
                    "add-notification": "Add notification",
                    "delete-notification": "Delete notification",
                    "no-notifications-prompt": "No notifications configured",
                    "notification-email": "Email",
                    "notification-sms": "SMS"
                },
                "application": {
                    "application": "Application",
                    "applications": "Applications",
                    "management": "Applications management",
                    "delete": "Delete application",
                    "assign-to-subCustomer": "Assign to Sub-Customer",
                    "unassign-from-subCustomer": "Unassign from Sub-Customer",
                    "copyId": "Copy application Id",
                    "idCopiedMessage": "Application Id has been copied to clipboard",
                    "name": "Name",
                    "name-required": "Name is required.",
                    "description": "Description",
                    "add": "Add Application",
                    "add-application-text": "Add new application",
                    "no-applications-text": "No applications found",
                    "application-details": "Application details",
                    "advanced-network-settings": "Advanced network settings",
                    "search": "Search applications",
                    "selected-applications": "{ count, plural, 1 {1 application} other {# applications} } selected",
                    "delete-application-title": "Are you sure you want to delete the application '{{name}}'?",
                    "delete-application-text": "Be careful, after the confirmation the application and all related data will become unrecoverable.",
                    "delete-applications-title": "Are you sure you want to delete { count, plural, 1 {1 application} other {# applications} }?",
                    "delete-applications-text": "Be careful, after the confirmation all selected applications will be removed and all related data will become unrecoverable.",
                    "application-not-found-text": "No Application matching '{{entity}}' were found.",
                    "target-application-required-text": "Target Application is required.",
                    "manage-devices": "Manage devices",
                    "manage-integrations": "Manage integrations",
                    "assign-application": "Assign application",
                    "select-target-assign-subCustomer-text": "Select target Sub-Customer to assign application",
                    "unassign-application-title": "Are you sure you want to unassign the application '{{applicationName}}'?",
                    "unassign-application-text": "After the confirmation the application will be unassigned and won't be accessible by the Sub-Customer.",
                    "unassign-application": "Unassign application",
                    "assigned-subCustomer": "Assigned to",
                    "abp-activation-title": "ABP (activation by personalisation)",
                    "abp-activation": "ABP activation",
                    "abp-activation-hint": "When checked, it means that the devices for this application will be manually activated and that over-the-air activation (OTAA) will be disabled.",
                    "send-encrypted-payload-title": "Send app payload encrypted to an Application Server",
                    "send-encrypted-payload": "Send app payload encrypted",
                    "send-encrypted-payload-hint": "When checked, it means that the devices payload that is pushed to Application Server(s) via MQTT will be encrypted using AppSKey. When unchecked, NS will decrypt payload before pushing to MQTT subscriptions."
                },
                "backups": {
                    "backups": "Backups",
                    "status": "Status",
                    "date": "Date",
                    "description": "Description",
                    "description-required": "Description is required.",
                    "create-backup": "Create backup",
                    "restore-backup": "Restore backup",
                    "no-backups-prompt": "No backups found",
                    "update-table": "Update table"
                },
                "confirm-on-exit": {
                    "message": "You have unsaved changes. Are you sure you want to leave this page?",
                    "html-message": "You have unsaved changes.<br/>Are you sure you want to leave this page?",
                    "title": "Unsaved changes"
                },
                "contact": {
                    "country": "Country",
                    "city": "City",
                    "state": "State",
                    "postal-code": "Postal code",
                    "postal-code-invalid": "Only digits are allowed.",
                    "address": "Address",
                    "address2": "Address 2",
                    "phone": "Phone",
                    "email": "Email",
                    "no-address": "No address"
                },
                "common": {
                    "username": "Username",
                    "username-required": "Username is required.",
                    "password": "Password",
                    "password-required": "Password is required.",
                    "enter-username": "Enter username",
                    "enter-password": "Enter password",
                    "enter-search": "Enter search"
                },
                "converter": {
                    "converter": "Data converter",
                    "converters": "Data converters",
                    "management": "Data converters management",
                    "no-converters-text": "No data converters found",
                    "selected-converters": "{ count, plural, 1 {1 data converter} other {# data converters} } selected",
                    "add": "Add Data Converter",
                    "converter-details": "Data converter details",
                    "search": "Search data converters",
                    "name": "Name",
                    "name-required": "Name is required.",
                    "type": "Type",
                    "type-required": "Type is required.",
                    "delete-converter-title": "Are you sure you want to delete the data converter '{{name}}'?",
                    "delete-converter-text": "Be careful, after the confirmation the data converter and all related data will become unrecoverable.",
                    "delete-converters-title": "Are you sure you want to delete { count, plural, 1 {1 data converter} other {# data converters} }?",
                    "delete-converters-text": "Be careful, after the confirmation all selected data converters will be removed and all related data will become unrecoverable.",
                    "decoder": "Decoder",
                    "encoder": "Encoder",
                    "converter-not-found-text": "No Data Converters matching '{{entity}}' were found.",
                    "converter-required": "Data Converter is required."
                },
                "converter-type": {
                    "cayenne-lpp": "Cayenne LPP",
                    "tek-industrial-sensor": "Tektelic Industrial Sensor",
                    "tek-home-sensor": "Tektelic Home Sensor",
                    "global-sat-lt100-sensor": "Global Sat LT100 Sensor",
                    "adeunis-915-rf-sensor": "Adeunis 915 RF Sensor",
                    "libelium-sensor": "Libelium Sensor",
                    "sensoro-sensor": "Sensoro Sensor",
                    "adeunis-8046-rf-sensor": "Adeunis 8046 RF Sensor",
                    "custom": "Custom"
                },
                "credentials": {
                    "manage": "Manage credentials",
                    "view": "View credentials",
                    "credentials": "Credentials",
                    "credentials-type": "Credentials type",
                    "basic": "Basic",
                    "username": "Username",
                    "username-required": "Username is required.",
                    "password": "Password",
                    "password-required": "Password is required.",
                    "x509_certificate": "X.509 Certificate",
                    "rsa-key": "RSA public key",
                    "rsa-key-required": "RSA public key is required.",
                },
                "customer": {
                    "customer": "Customer",
                    "customers": "Customers",
                    "management": "Customers management",
                    "title": "Title",
                    "title-required": "Title is required.",
                    "description": "Description",
                    "copyId": "Copy customer Id",
                    "idCopiedMessage": "Customer Id has been copied to clipboard",
                    "manage-users": "Manage users",
                    "manage-gateways": "Manage gateways",
                    "add": "Add Customer",
                    "delete": "Delete customer",
                    "add-customer-text": "Add new customer",
                    "no-customers-text": "No customers found",
                    "customer-details": "Customer details",
                    "search": "Search customers",
                    "selected-customers": "{ count, plural, 1 {1 customer} other {# customers} } selected",
                    "delete-customer-title": "Are you sure you want to delete the customer '{{title}}'?",
                    "delete-customer-text": "Be careful, after the confirmation the customer and all related data will become unrecoverable.",
                    "delete-customers-title": "Are you sure you want to delete { count, plural, 1 {1 customer} other {# customers} }?",
                    "delete-customers-text": "Be careful, after the confirmation all selected customers will be removed and all related data will become unrecoverable.",
                    "customer-not-found-text": "No Customers matching '{{entity}}' were found.",
                    "target-customer-required-text": "Target Customer is required.",
                    "customer-required": "Customer is required.",
                    "subCustomers-count": "#of Sub-Customers",
                    "gateways-count": "#of GWs",
                    "devices-count": "#of Devices",
                    "number-of-subCustomers": "Number of Sub-Customers",
                    "number-of-gateways": "Number of gateways",
                    "number-of-devices": "Number of devices"
                },
                "datetime": {
                    "date-from": "Date from",
                    "time-from": "Time from",
                    "date-to": "Date to",
                    "time-to": "Time to"
                },
                "dialog": {
                    "close": "Close dialog"
                },
                "device": {
                    "device": "Device",
                    "devices": "Devices",
                    "add": "Add Device",
                    "no-devices-text": "No devices found",
                    "device-details": "Device details",
                    "device-packets": "Real-time packets",
                    "advanced-network-settings": "Advanced network settings",
                    "search": "Search devices",
                    "selected-devices": "{ count, plural, 1 {1 device} other {# devices} } selected",
                    "delete": "Delete device",
                    "copyId": "Copy device Id",
                    "idCopiedMessage": "Device Id has been copied to clipboard",
                    "name": "Name",
                    "name-required": "Name is required.",
                    "device-class": "Device class",
                    "device-eui": "Device EUI",
                    "device-eui-required": "Device EUI is required.",
                    "device-eui-invalid": "Please enter a valid device EUI (16 hexadecimal numbers).",
                    "app-eui": "Application EUI",
                    "app-eui-required": "Application EUI is required.",
                    "app-eui-invalid": "Please enter a valid application EUI (16 hexadecimal numbers).",
                    "app-key": "Application Key",
                    "app-key-required": "Application Key is required.",
                    "app-key-invalid": "Please enter a valid application key (16 hexadecimal numbers).",
                    "description": "Description",
                    "move-to-application": "Move to application",
                    "select-target-move-application-text": "Select target application to move device",
                    "select-target-move-application-devices-text": "Select target application to move devices",
                    "delete-device-title": "Are you sure you want to delete the device '{{name}}'?",
                    "delete-device-text": "Be careful, after the confirmation the device and all related data will become unrecoverable.",
                    "delete-devices-title": "Are you sure you want to delete { count, plural, 1 {1 device} other {# devices} }?",
                    "delete-devices-text": "Be careful, after the confirmation all selected devices will be removed and all related data will become unrecoverable.",
                    "use-application-settings": "Use application settings",
                    "use-application-settings-hint": "When checked, it means that the node will use the (network) settings as set by the application. In case this node requires node-specific (network) settings, uncheck this box.",
                    "inactivity-timeout": "Inactivity timeout (sec)",
                    "status": "Status",
                    "online": "Online",
                    "offline": "Offline",
                    "last-activity-time": "Last activity time",
                    "battery-level": "Battery level",
                    "battery-external-source": "Device is connected to an external power source",
                    "battery-no-able-to-measure": "Device was not able to measure the battery level",
                    "margin": "Margin",
                    "request-status": "Request device status",
                    "status-requested-message": "Device status request has been successfully scheduled.",
                    "timestamp": "Timestamp",
                    "gateway": "Gateway",
                    "rssi": "RSSI",
                    "antenna": "Ant",
                    "frequency": "Frequency",
                    "channel": "CH",
                    "code-rate": "CR",
                    "lora-snr": "SNR",
                    "spread-factor": "SF",
                    "bandwidth": "BW",
                    "message-type": "Message Type",
                    "raw-payload": "Payload",
                    "f-cnt-up": "FCntUp",
                    "f-cnt-down": "FCntDown",
                    "duty-cycled": "Duty Cycled",
                    "duty-cycled-yes": "Yes",
                    "abp-activation-title": "ABP (activation by personalisation)",
                    "abp-activation": "ABP activation",
                    "abp-activation-hint": "When checked, it means that the device will be manually activated and that over-the-air activation (OTAA) will be disabled.",
                    "activation": "Activation",
                    "device-address": "Device address",
                    "device-address-invalid": "Please enter a valid device address (4 hexadecimal numbers).",
                    "generate": "generate",
                    "network-session-key": "Network session key",
                    "network-session-key-invalid": "Please enter a valid network session key (16 hexadecimal numbers).",
                    "application-session-key": "Application session key",
                    "application-session-key-invalid": "Please enter a valid application session key (16 hexadecimal numbers).",
                    "uplink-frame-counter": "Uplink frame-counter",
                    "downlink-frame-counter": "Downlink frame-counter",
                    "bulk-provisioning-title": "Device bulk commissioning",
                    "downlinks": {
                        "downlink-queue": "Downlink queue",
                        "msg-id": "Message ID",
                        "port": "Port",
                        "confirmed": "Confirmed",
                        "data": "Data",
                        "empty-queue-prompt": "Device has no downlinks in the queue",
                        "clear-downlink-queue": "Clear downlink queue",
                        "clear-downlink-queue-hint": "Clear all pending downlink messages",
                        "clear-queue-warning-title": "Are you sure you want to clear the downlink queue for '{{deviceName}}'",
                        "clear-queue-warning-content": "Be careful, after the confirmation all pending downlinks will be cleared.",
                        "update-downlink-queue": "Update downlink queue",
                        "update-downlink-queue-hint": "Note that the queue isn't updated automatically. Press the button to get the actual downlink queue"
                    }
                },
                "device-class": {
                    "class-a": "Class A",
                    "class-b": "Class B",
                    "class-c": "Class C"
                },
                "device-model": {
                    "device-model": "Device model",
                    "device-models": "Device models",
                    "management": "Device models management",
                    "no-device-models-text": "No device models found",
                    "selected-device-models": "{ count, plural, 1 {1 device model} other {# device models} } selected",
                    "add": "Add Device Model",
                    "device-model-details": "Device model details",
                    "search": "Search device models",
                    "manufacturer": "Manufacturer",
                    "manufacturer-required": "Manufacturer is required.",
                    "name": "Name",
                    "name-required": "Name is required.",
                    "type": "Type",
                    "type-required": "Type is required.",
                    "device-class": "Device class",
                    "device-class-required": "Device class is required.",
                    "delete-device-model-title": "Are you sure you want to delete the device model '{{name}}'?",
                    "delete-device-model-text": "Be careful, after the confirmation the device model and all related data will become unrecoverable.",
                    "delete-device-models-title": "Are you sure you want to delete { count, plural, 1 {1 device model} other {# device models} }?",
                    "delete-device-models-text": "Be careful, after the confirmation all selected device models will be removed and all related data will become unrecoverable.",
                    "device-model-not-found-text": "No Device Models matching '{{entity}}' were found.",
                    "device-model-required": "Device Model is required.",
                    "description": "Description"
                },
                "details": {
                    "details": "Details",
                    "edit-mode": "Edit mode",
                    "toggle-edit-mode": "Toggle edit mode"
                },
                "email": {
                    "invalid-format": "Invalid email format.",
                    "contact-list-required": "At least one email contact is required.",
                    "from": "From",
                    "from-required": "From is required.",
                    "to": "To (press enter to add)",
                    "enter-recipients": "Enter recipients",
                    "add-to": "+To",
                    "cc": "Cc (press enter to add)",
                    "add-cc": "+Cc",
                    "bcc": "Bcc (press enter to add)",
                    "add-bcc": "+Bcc",
                    "subject": "Subject",
                    "subject-required": "Mail subject is required.",
                    "body": "Body",
                    "body-required": "Mail body is required."
                },
                "sms": {
                    "to": "To (press enter to add)",
                    "enter-recipients": "Enter recipients",
                    "add-to": "+To",
                    "contact-list-required": "At least one sms contact is required.",
                    "body": "Body",
                    "body-required": "SMS body is required."
                },
                "error": {
                    "unable-to-connect": "Unable to connect to the server! Please check your internet connection.",
                    "unhandled-error-code": "Unhandled error code: {{errorCode}}",
                    "unknown-error": "Unknown error"
                },
                "entity-field": {
                    "createdTime": "Created Time"
                },
                "entity": {
                    "createdTime": "Created Time"
                },
                "entity-table": {
                    "delete-entity-title": "Are you sure you want to delete this item?",
                    "delete-entity-text": "Be careful, after the confirmation this item and all related data will become unrecoverable.",
                    "delete-entities-title": "Are you sure you want to delete { count, plural, 1 {1 entity} other {# entities} }?",
                    "delete-entities-text": "Be careful, after the confirmation all selected items will be removed and all related data will become unrecoverable.",
                    "delete-entity": "Delete Entity",
                    "delete-entities": "Delete Entities"
                },
                "event": {
                    "events": "Events",
                    "no-events-prompt": "No events found",
                    "event-type": "Event type",
                    "event-types": "Event types",
                    "type": "Type",
                    "alarms": "Alarms",
                    "faults": "Faults",
                    "alarm": "Alarm",
                    "fault": "Fault",
                    "event": "Event",
                    "online": "Online",
                    "offline": "Offline",
                    "severity-critical": "Critical",
                    "severity-major": "Major",
                    "severity-minor": "Minor",
                    "state-clear": "Clear",
                    "state-raised": "Raised",
                    "search-events": "Search events",
                    "start-time": "Start time",
                    "end-time": "End time",
                    "severity": "Severity",
                    "severity-required": "Severity is required",
                    "description": "Description",
                    "state": "State",
                    "state-required": "State is required",
                    "entity": "Entity",
                    "label": "Label",
                    "gateway-details": "Gateway details",
                    "device-details": "Device details",
                    "integration-details": "Integration details"
                },
                "firewall": {
                    "firewall": "Firewall",
                    "read-configuration": "Read Firewall Configuration",
                    "set-configuration": "Set Firewall Configuration",
                    "firewall-enabled": "Firewall Enabled",
                    "filters": "Filters",
                    "insert-filter": "Insert Filter",
                    "append-filter": "Append Filter",
                    "move-up": "Move Up",
                    "move-down": "Move Down",
                    "name": "Name",
                    "description": "Description",
                    "chain": "Chain",
                    "target": "Target",
                    "enabled": "Enabled",
                    "delete": "Delete",
                    "edit-filter": "Edit filter",
                    "view-filter": "View filter",
                    "create-filter": "Create filter",
                    "no-filters-prompt": "No filters configured",
                    "filter-enabled": "Filter Enabled",
                    "filter-name": "Filter Name",
                    "filter-name-required": "Filter name is required",
                    "filter-description": "Filter Description",
                    "filter-description-required": "Filter description is required",
                    "mark-for-deletion": "Mark for deletion",
                    "advanced-mode": "Advanced Mode",
                    "filter-chain": "Chain",
                    "filter-chain-required": "Filter chain is required",
                    "dst-port-range": "Dest. port range",
                    "protocol": "Protocol",
                    "filter-target": "Target",
                    "filter-target-required": "Filter target is required",
                    "dst-interface": "Destination Interface",
                    "dst-addr": "Destination Addr",
                    "dst-mask": "Destination Mask",
                    "src-interface": "Source Interface",
                    "src-addr": "Source Addr",
                    "src-mask": "Source Mask",
                    "src-port-range": "Source port range",
                    "src-mac": "Source MAC",
                    "icmp": "ICMP",
                    "icmp-enabled": "Enabled",
                    "icmp-disabled": "Disabled",
                    "rate-limit": "Rate Limit",
                    "rate-limit-enabled": "Enabled",
                    "rate-limit-disabled": "Disabled",
                    "ping-per-min-limit": "Avg. req. per second",
                    "ping-burst-limit": "Burst Limit",
                    "ssh": "SSH",
                    "ssh-enabled": "Enabled",
                    "ssh-disabled": "Disabled",
                    "ip-defence": "Ip Defence",
                    "ip-defence-enabled": "Enabled",
                    "ip-defence-disabled": "Disabled",
                    "ip-defence-per-min-limit": "Avg. new conn. per min",
                    "ip-defence-burst-limit": "Burst Limit"
                },
                "spectrum-analyzer": {
                    "spectrum-analyzer": "Spectrum Analyzer",
                    "sample-period": "Sample Period, &micro;s",
                    "sample-count": "Average count",
                    "start-frequency": "Start Frequency, kHz",
                    "stop-frequency": "Stop Frequency, kHz",
                    "bin-spacing": "Bin Spacing, kHz",
                    "antenna": "Antenna",
                    "antenna-selection": "Antenna Selection",
                    "antenna0": "Antenna 0",
                    "antenna1": "Antenna 1",
                    "antenna-both": "Both",
                    "start-spectrum-analyzer": "Start Spectrum Analyzer",
                    "stop-spectrum-analyzer": "Stop Spectrum Analyzer",
                    "spectrum-plot-frequency-title": "Frequency (MHz)",
                    "spectrum-plot-power-title": "Power (dBm)",
                    "spectrum-flot-power-bins-title": "Power bins (dBm)",
                    "spectrum-flot-count-title": "Count",
                    "minimum": "Minimum",
                    "maximum": "Maximum",
                    "auto": "Auto",
                    "spectral-scan": "Spectral Scan",
                    "start-spectral-scan": "Start Spectral Scan",
                    "stop-spectral-scan": "Stop Spectral Scan",
                    "num-125-k-chan": "Num 125kHz Chan",
                    "start-freq-125-k": "125kHz Start Freq, kHz",
                    "step-freq-125-k": "125kHz Step Size, kHz",
                    "num-500-k-chan": "Num 500kHz Chan",
                    "start-freq-500-k": "500kHz Start Freq, kHz",
                    "step-freq-500-k": "500kHz Step Size, kHz",
                    "export-to-file": "Export to file",
                    "import-from-file": "Import from file",
                    "import-spectral-scan-results": "Import Spectral Scan Results",
                    "spectral-scan-results-file": "Spectral Scan Results File",
                    "power-over-frequency": "{{percents}} power over frequency",
                    "channel-list-item": "{{prefix}} channel {{index}} - {{frequency}}",
                    "channels": "Channels"
                },
                "radio-statistics": {
                    "radio-statistics": "Radio Statistics",
                    "num-tx-packets": "# of transmitted packets",
                    "num-rx-packets": "# of received packets",
                    "rx-fine-timestamp": "With fine timestamp",
                    "rx-no-fine-timestamp": "Without fine timestamp",
                    "rx-crc-ok-packets": "CRC passed",
                    "rx-crc-err-packets": "CRC fail",
                    "rx-error-rate": "Rx packet error rate",
                    "no-match": "No match",
                    "reset-counters": "Reset Counters",
                    "polling-interval": "Polling Interval, s",
                    "poll-now": "Poll Now",
                    "do-not-poll": "Do Not Poll"
                },
                "fullscreen": {
                    "expand": "Expand to fullscreen",
                    "exit": "Exit fullscreen",
                    "toggle": "Toggle fullscreen mode",
                    "fullscreen": "Fullscreen"
                },
                "gateway": {
                    "gateway": "Gateway",
                    "gateways": "Gateways",
                    "management": "Gateways management",
                    "delete": "Delete gateway",
                    "assign-to-customer": "Assign to customer",
                    "unassign-from-customer": "Unassign from customer",
                    "copyId": "Copy gateway Id",
                    "idCopiedMessage": "Gateway Id has been copied to clipboard",
                    "name": "Name",
                    "name-required": "Name is required.",
                    "mac": "GW-ID",
                    "mac-required": "GW-ID is required.",
                    "mac-invalid": "Please enter a valid GW-ID (16 hexadecimal numbers).",
                    "public": "Public",
                    "messages-logging": "Logging enabled",
                    "description": "Description",
                    "latitude": "Latitude",
                    "longitude": "Longitude",
                    "altitude": "Altitude",
                    "add": "Add Gateway",
                    "add-gateway-text": "Add new gateway",
                    "no-gateways-text": "No gateways found",
                    "gateway-details": "Gateway details",
                    "location": "Location",
                    "model": "Model",
                    "channel-plan": "Channel plan",
                    "events": "Events",
                    "gateway-stats": "Statistics",
                    "gateway-statistics": "Gateway statistics",
                    "search-statistics": "Search statistics",
                    "search": "Search gateways",
                    "selected-gateways": "{ count, plural, 1 {1 gateway} other {# gateways} } selected",
                    "delete-gateway-title": "Are you sure you want to delete the gateway '{{name}}'?",
                    "delete-gateway-text": "Be careful, after the confirmation the gateway and all related data will become unrecoverable.",
                    "delete-gateways-title": "Are you sure you want to delete { count, plural, 1 {1 gateway} other {# gateways} }?",
                    "delete-gateways-text": "Be careful, after the confirmation all selected gateways will be removed and all related data will become unrecoverable.",
                    "assign-gateway": "Assign gateway",
                    "select-target-assign-customer-text": "Select target customer to assign gateway",
                    "unassign-gateway-title": "Are you sure you want to unassign the gateway '{{gatewayName}}'?",
                    "unassign-gateway-text": "After the confirmation the gateway will be unassigned and won't be accessible by the customer.",
                    "unassign-gateway": "Unassign gateway",
                    "assigned-customer": "Assigned to",
                    "inactivity-timeout": "Inactivity timeout (sec)",
                    "status": "Status",
                    "online": "Online",
                    "offline": "Offline",
                    "state": "State",
                    "enabled": "Enabled",
                    "disabled": "Disabled",
                    "enable": "Enable",
                    "disable": "Disable",
                    "last-activity-time": "Last activity time",
                    "timestamp": "Timestamp",
                    "rx-packets-received": "RX received",
                    "rx-packets-received-ok": "RX received OK",
                    "tx-packets-received": "TX received",
                    "tx-packets-emitted": "TX emitted",
                    "move-to-gateway-group": "Move to gateway group",
                    "select-target-move-gateway-group-text": "Select target group to move gateway",
                    "select-target-move-gateway-group-gateways-text": "Select target group to move gateways",
                    "commands": "Commands",
                    "command": "Command",
                    "execute": "Execute",
                    "download-ns-mqtts-cert": "Download NS certificate",
                    "ns-mqtts-cert-downloaded-msg-ok": "NS certificate has been downloaded",
                    "bulk-provisioning-title": "Gateway bulk commissioning"
                },
                "gateway-command": {
                    "reboot": "Reboot",
                    "ping": "Ping",
                    "get-public-key": "Get public key",
                    "reverse-ssh": "Establish reverse SSH session",
                    "stop-reverse-ssh": "Terminate all reverse SSH sessions",
                    "number-of-packets": "Number of packets",
                    "number-of-packets-required": "Number of packets is required.",
                    "destination": "Destination",
                    "destination-required": "Destination is required",
                    "options": "Options",
                    "ssh-host": "SSH host",
                    "ssh-host-required": "SSH host is required.",
                    "ssh-port": "SSH port",
                    "ssh-port-required": "SSH port is required.",
                    "ssh-rev-port": "Reverse SSH port (default is 9000)",
                    "username": "Username",
                    "username-required": "Username is required.",
                    "password": "Password",
                    "execute-script": "Execute script",
                    "script": "Script",
                    "not-supported": "Command not supported",
                    "get-antennas-count": "Get antennas count"
                },
                "gateway-log": {
                    "gateway-logs": "Gateway logs",
                    "no-logs-prompt": "No logs were found",
                    "time": "Time",
                    "mac": "GW-ID",
                    "msg-type": "Type of message",
                    "payload": "Payload",
                    "payload-details": "Payload details",
                    "gw-statistics": "Gateway statistics",
                    "gw-alarm-event": "Gateway alarm event",
                    "gw-rpc-command": "Gateway RPC command",
                    "gw-rpc-response": "Gateway RPC response",
                    "gw-configuration-update": "Gateway configuration update",
                    "gw-configuration-request": "Gateway configuration event",
                    "gw-event": "Gateway event",
                    "device-alarm-event": "Device alarm event",
                    "join-request": "Join request",
                    "join-accept": "Join accept",
                    "unconfirmed-data-up": "Unconfirmed data up",
                    "unconfirmed-data-down": "Unconfirmed data down",
                    "confirmed-data-up": "Confirmed data up",
                    "confirmed-data-down": "Confirmed data down",
                    "rfu": "RFU",
                    "proprietary": "Proprietary",
                },
                "gateway-group": {
                    "gateway-group": "Gateway group",
                    "gateway-groups": "Gateway groups",
                    "management": "Gateway groups management",
                    "delete": "Delete gateway group",
                    "assign-to-customer": "Assign to customer",
                    "unassign-from-customer": "Unassign from customer",
                    "copyId": "Copy gateway group Id",
                    "idCopiedMessage": "Gateway group Id has been copied to clipboard",
                    "name": "Name",
                    "name-required": "Name is required.",
                    "description": "Description",
                    "gateways-count": "# of gateways",
                    "add": "Add Gateway group",
                    "add-gateway-group-text": "Add new gateway group",
                    "no-gateway-groups-text": "No gateway groups found",
                    "gateway-group-details": "Gateway group details",
                    "search": "Search gateway groups",
                    "selected-gateway-groups": "{ count, plural, 1 {1 gateway group} other {# gateway groups} } selected",
                    "delete-gateway-group-title": "Are you sure you want to delete the gateway group '{{name}}'?",
                    "delete-gateway-group-text": "Be careful, after the confirmation the gateway group and all related data will become unrecoverable.",
                    "delete-gateway-groups-title": "Are you sure you want to delete { count, plural, 1 {1 gateway group} other {# gateway groups} }?",
                    "delete-gateway-groups-text": "Be careful, after the confirmation all selected gateway groups will be removed and all related data will become unrecoverable.",
                    "assign-gateway-group": "Assign gateway group",
                    "assign-gateway-groups": "Assign gateway groups",
                    "select-target-assign-customer-text": "Select target customer to assign gateway group",
                    "select-target-assign-customer-gateway-groups-text": "Select target customer to assign gateway groups",
                    "unassign-gateway-group-title": "Are you sure you want to unassign the gateway group '{{gatewayGroupName}}'?",
                    "unassign-gateway-group-text": "After the confirmation the gateway group will be unassigned and won't be accessible by the customer.",
                    "unassign-gateway-group": "Unassign gateway group",
                    "unassign-gateway-groups-title": "Are you sure you want to unassign { count, plural, 1 {1 gateway group} other {# gateway groups} }?",
                    "unassign-gateway-groups-text": "After the confirmation the selected gateway groups will be unassigned and won't be accessible by the customer.",
                    "unassign-gateway-groups": "Unassign gateway groups",
                    "assigned-customer": "Assigned to",
                    "manage-gateways": "Manage gateways",
                    "gateway-group-not-found-text": "No Gateway groups matching '{{entity}}' were found.",
                    "target-gateway-group-required-text": "Target Gateway group is required."
                },
                "gateway-frequency": {
                    "as-923": "AS-923",
                    "as-920-923": "AS-920-923",
                    "as-923-925": "AS-923-925",
                    "us-902-928": "US-902-928",
                    "eu-863-870": "EU-863-870",
                    "cn-470-510": "CN-470-510",
                    "au-915-928": "AU-915-928",
                    "ru-864-870": "RU-864-870",
                    "in-865-867": "IN-865-867",
                    "isr-915-917": "ISR-915-917",
                    "kr-920-923": "KR-920-923"
                },
                "gateway-frequency-info": {
                    "channels": "Channels",
                    "channel-bw-up": "Channel BW Up",
                    "channel-bw-dn": "Channel BW Dn",
                    "tx-power-up": "TX Power Up",
                    "tx-power-dn": "TX Power Dn",
                    "sf-up": "SF Up",
                    "data-rate": "Data Rate",
                    "link-budget-up": "Link Budget Up",
                    "link-budget-dn": "Link Budget Dn"
                },
                "gateway-info": {
                    "gateway-info": "Gateway Info",
                    "module-name": "Module Name",
                    "product-code": "TCODE",
                    "module-revision": "Module Revision",
                    "serial-number": "Serial Number",
                    "gateway-id": "Gateway ID"
                },
                "gateway-model": {
                    "gateway-model": "Gateway model",
                    "gateway-models": "Gateway models",
                    "no-gateway-models-text": "No gateway models found",
                    "selected-gateway-models": "{ count, plural, 1 {1 gateway model} other {# gateway models} } selected",
                    "add": "Add Gateway Model",
                    "gateway-model-details": "Gateway model details",
                    "search": "Search gateway models",
                    "manufacturer": "Manufacturer",
                    "manufacturer-required": "Manufacturer is required.",
                    "name": "Name",
                    "name-required": "Name is required.",
                    "gateway-frequency": "Frequency band",
                    "gateway-frequency-required": "Frequency band is required.",
                    "gateway-channels": "Channels",
                    "gateway-channels-required": "Channels is required.",
                    "delete-gateway-model-title": "Are you sure you want to delete the gateway model '{{name}}'?",
                    "delete-gateway-model-text": "Be careful, after the confirmation the gateway model and all related data will become unrecoverable.",
                    "delete-gateway-models-title": "Are you sure you want to delete { count, plural, 1 {1 gateway model} other {# gateway models} }?",
                    "delete-gateway-models-text": "Be careful, after the confirmation all selected gateway models will be removed and all related data will become unrecoverable.",
                    "gateway-model-not-found-text": "No Gateway Models matching '{{entity}}' were found.",
                    "gateway-model-required": "Gateway Model is required.",
                    "description": "Description"
                },
                "hardware-entities": {
                    "entities": "Entities",
                    "search-gateway": "Search gateway by GW-ID",
                    "search-device": "Search device by EUI",
                    "gateway-not-found-text": "No Gateway matching '{{mac}}' was found",
                    "device-not-found-text": "No Device matching '{{eui}}' was found",
                    "gateway-was-deleted": "Gateway with GW-ID '{{mac}}' was deleted",
                    "device-was-deleted": "Device with EUI '{{eui}}' was deleted"
                },
                "help": {
                    "goto-help-page": "Go to help page"
                },
                "home": {
                    "home": "Home",
                    "profile": "Profile",
                    "logout": "Logout",
                    "menu": "Menu",
                    "avatar": "Avatar",
                    "open-user-menu": "Open user menu"
                },
                "import": {
                    "no-file": "No file selected",
                    "drop-file": "Drop a file or click to select a file to upload"
                },
                "integration": {
                    "integration": "Integration",
                    "integrations": "Integrations",
                    "http-endpoint": "HTTP URL path",
                    "no-integrations-text": "No integrations found",
                    "selected-integrations": "{ count, plural, 1 {1 integration} other {# integrations} } selected",
                    "add": "Add Integration",
                    "integration-details": "Integration details",
                    "search": "Search integrations",
                    "name": "Name",
                    "name-required": "Name is required.",
                    "type": "Type",
                    "type-required": "Type is required.",
                    "delete-integration-title": "Are you sure you want to delete the integration '{{name}}'?",
                    "delete-integration-text": "Be careful, after the confirmation the integration and all related data will become unrecoverable.",
                    "delete-integrations-title": "Are you sure you want to delete { count, plural, 1 {1 integration} other {# integrations} }?",
                    "delete-integrations-text": "Be careful, after the confirmation all selected integrations will be removed and all related data will become unrecoverable.",
                    "host": "Application address (IP or name without http or https prefix)",
                    "host-required": "Application address is required",
                    "port": "Port",
                    "port-required": "Port is required",
                    "port-invalid": "That doesn't look like a valid port.",
                    "base-path": "Base path",
                    "base-path-required": "Base path is required",
                    "auth-method": "Authentication method",
                    "auth-method-required": "Authentication method is required",
                    "auth-method-type": {
                        "no-auth": "No authentication",
                        "basic-auth": "Basic authentication"
                    },
                    "request-headers": "Request headers",
                    "enable-tls": "Enable TLS",
                    "enable-https": "Enable HTTPS",
                    "token": "Token",
                    "token-required": "Token is required.",
                    "push-topic": "Push Topic",
                    "pull-topic": "Pull Topic",
                    "topic-required": "Topic is required.",
                    "client-id": "Client ID",
                    "retry-interval": "Retry interval (seconds)",
                    "retry-interval-invalid": "That doesn't look like a valid retry interval."
                },
                "integration-type": {
                    "http": "HTTP",
                    "mqtt": "MQTT",
                    "thingsboard": "ThingsBoard",
                    "azure": "Azure IoT Hub proxy"
                },
                "configuration-type": {
                    "general": "General",
                    "frequency": "Frequency",
                    "antenna": "Antenna",
                    "upgrade-servers": "Upgrade Servers",
                    "automatic-updates": "Automatic Updates"
                },
                "content-type": {
                    "json": "Json",
                    "text": "Text",
                    "binary": "Binary (Base64)"
                },
                "configuration": {
                    "configuration": "Configuration",
                    "configurations": "Configurations",
                    "add-configuration": "Add configuration",
                    "remote-configuration": "Remote configuration",
                    "configuration-type": "Configuration type",
                    "configuration-type-required": "Configuration type is required.",
                    "type": "Type",
                    "content-type": "Content type",
                    "content-type-required": "Content type is required.",
                    "content": "Content",
                    "sync-status": "Sync status",
                    "synced": "Synced",
                    "not-synced": "Not Synced",
                    "update-ts": "Update time",
                    "remote-update-ts": "Last sync time",
                    "edit-configuration": "Edit configuration",
                    "view-configuration": "View configuration",
                    "delete-configuration": "Delete configuration",
                    "delete-configuration-title": "Are you sure you want to delete '{{configurationType}}' configuration?",
                    "delete-configuration-text": "Be careful, after the confirmation the configuration and all related data will become unrecoverable.",
                    "no-remote-configuration": "No remote configuration available",
                    "no-configuration": "No configuration available",
                    "use-group-configuration": "Use group configuration",
                    "no-group-configuration": "No group configuration available",
                    "group-configuration-details": "Group configuration details",
                    "scope": "Scope",
                    "gateway-scope": "Gateway",
                    "group-scope": "Group"
                },
                "js-func": {
                    "no-return-error": "Function must return value!",
                    "return-type-mismatch": "Function must return value of '{{type}}' type!"
                },
                "key-val": {
                    "key": "Key",
                    "value": "Value",
                    "remove-entry": "Remove entry",
                    "add-entry": "Add entry"
                },
                "login": {
                    "login": "Login",
                    "request-password-reset": "Request Password Reset",
                    "reset-password": "Reset Password",
                    "create-password": "Create Password",
                    "passwords-mismatch-error": "Entered passwords must be same!",
                    "password-again": "Password again",
                    "sign-in": "Please sign in",
                    "username": "Username (email)",
                    "remember-me": "Remember me",
                    "forgot-password": "Forgot Password?",
                    "password-reset": "Password reset",
                    "new-password": "New password",
                    "new-password-again": "New password again",
                    "password-link-sent-message": "Password reset link was successfully sent!",
                    "email": "Email"
                },
                "networkSettings": {
                    "receive-window": "Receive window",
                    "rx1": "RX1",
                    "rx2": "RX2 (one second after RX1)",
                    "relax-frame-counter": "Relax frame-counter",
                    "enable-relax-frame-counter": "Enable relax frame-counter",
                    "relax-frame-counter-hint": "Note that relax frame-counter mode will compromise security as it enables people to perform replay-attacks.",
                    "receive-window-delay": "Receive window delay",
                    "receive-window-delay-hint": "The delay in seconds (0-15) between the end of the TX uplink and the opening of the first reception slot (0=1 sec, 1=1 sec, 2=2 sec, 3=3 sec, ... 15=15 sec).",
                    "rx1-data-rate-offset": "RX1 data-rate offset",
                    "rx1-data-rate-offset-hint": "Sets the offset between the uplink data rate and the downlink data-rate used to communicate with the end-device on the first reception slot (RX1). Please refer to the LoRaWAN specs for the values that are valid in your region.",
                    "rx2-data-rate": "RX2 data-rate",
                    "rx2-data-rate-hint": "The data-rate to use when RX2 is used as receive window. Please refer to the LoRaWAN specs for the values that are valid in your region.",
                    "adr": "ADR",
                    "enable-adr": "Enable ADR",
                    "adr-hint": "Advanced data rate mode enables network-server to ask the node to change data-rate and / or TX power if it can change to a better data-rate or lower TX power.",
                    "installation-margin": "Installation margin (dB)",
                    "installation-margin-hint": "The installation margin which is taken into account when calculating the ideal data-rate and TX power. A higher margin will lower the data-rate, a lower margin will increase the data-rate and possibly packet loss. 5dB is the default recommended value.",
                    "cf-list": "Channel frequency list (MHz)",
                    "cf-list-placeholder": "Enter frequency in MHz",
                    "cf-list-hint": "Optional channel frequency list to be used by the end-device.",
                    "default-channel-mask": "Default channel mask",
                    "not-defined-channel-mask": "Not defined",
                    "8-channel": "8-channel",
                    "64-channel": "64-channel",
                    "custom-channel-mask": "Custom channel mask",
                    "channel-mask": "ChMask",
                    "channel-mask-control": "ChMaskCtrl",
                    "channel-mask-required": "ChMask is required.",
                    "channel-mask-control-required": "ChMaskCtrl is required.",
                    "remove-channel-mask-entry": "Remove ChMask entry",
                    "add-channel-mask-entry": "Add ChMask entry",
                    "channel-mask-invalid": "Invalid ChMask, must be 2 bytes hex (ex. 0x0001)",
                    "channel-mask-control-invalid": "Invalid ChMaskCtrl, must be 1 byte hex (ex. 0x01)"
                },
                "profile": {
                    "profile": "Profile",
                    "change-password": "Change Password",
                    "current-password": "Current password"
                },
                "provider": {
                    "provider": "Provider",
                    "providers": "Providers",
                    "management": "Providers management",
                    "title": "Title",
                    "title-required": "Title is required.",
                    "net-id": "Net ID",
                    "net-id-required": "Net ID is required.",
                    "net-id-invalid": "Please enter a valid Net Id (3 hexadecimal numbers).",
                    "description": "Description",
                    "copyId": "Copy provider Id",
                    "idCopiedMessage": "Provider Id has been copied to clipboard",
                    "manage-users": "Manage users",
                    "add": "Add Provider",
                    "delete": "Delete provider",
                    "add-provider-text": "Add new provider",
                    "no-providers-text": "No providers found",
                    "provider-details": "Provider details",
                    "search": "Search providers",
                    "selected-providers": "{ count, plural, 1 {1 provider} other {# providers} } selected",
                    "delete-provider-title": "Are you sure you want to delete the provider '{{title}}'?",
                    "delete-provider-text": "Be careful, after the confirmation the provider and all related data will become unrecoverable.",
                    "delete-providers-title": "Are you sure you want to delete { count, plural, 1 {1 provider} other {# providers} }?",
                    "delete-providers-text": "Be careful, after the confirmation all selected providers will be removed and all related data will become unrecoverable.",
                    "provider-not-found-text": "No Providers matching '{{entity}}' were found.",
                    "provider-required": "Provider is required.",
                    "customers-count": "#of Customers",
                    "gateways-count": "#of GWs",
                    "devices-count": "#of Devices",
                    "number-of-customers": "Number of customers",
                    "number-of-gateways": "Number of gateways",
                    "number-of-devices": "Number of devices"
                },
                "port": {
                    "from": "From",
                    "to": "To",
                    "invalid-start-port": "Invalid starting port",
                    "lower-greater-than-upper": "Lower range is greater than upper range"
                },
                "subscription": {
                    "management": "Subscription Plans Management",
                    "subscription": "Subscription Plan",
                    "subscriptions": "Subscription Plans",
                    "name": "Name",
                    "name-required": "Name is required.",
                    "price": "Pricing/month, $",
                    "price-required": "Pricing is required.",
                    "ticket-support": "Ticket Support",
                    "tech-support": "Tech Support",
                    "renewal-price": "Renewal price",
                    "no-subscriptions-text": "No Subscription Plans found",
                    "selected-subscriptions": "{ count, plural, 1 {1 subscription plan} other {# subscription plans} } selected",
                    "add": "Add Subscription Plan",
                    "subscription-details": "Subscription Plan details",
                    "search": "Search subscription plans",
                    "delete-subscription-title": "Are you sure you want to delete the subscription plan '{{name}}'?",
                    "delete-subscription-text": "Be careful, after the confirmation the subscription plan and all related data will become unrecoverable.",
                    "delete-subscriptions-title": "Are you sure you want to delete { count, plural, 1 {1 subscription plan} other {# subscription plans} }?",
                    "delete-subscriptions-text": "Be careful, after the confirmation all selected subscription plans will be removed and all related data will become unrecoverable.",
                    "subscription-not-found-text": "No Subscription Plans matching '{{entity}}' were found.",
                    "subscription-required": "Subscription Plan is required.",
                    "since": "Since",
                    "number-of-total": "{{count}} out of {{total}}"
                },
                "subscription-error": {
                    "title": "Subscription violation",
                    "limit-reached": {
                        "max-provider-gateways": "You have reached maximum gateways ({{value}}) allowed by your provider subscription!",
                        "max-customer-gateways": "You have reached maximum gateways ({{value}}) allowed by your customer subscription!",
                        "max-provider-applications": "You have reached maximum applications ({{value}}) allowed by your provider subscription!",
                        "max-customer-applications": "You have reached maximum applications ({{value}}) allowed by your customer subscription!",
                        "max-provider-devices": "You have reached maximum devices ({{value}}) allowed by your provider subscription!",
                        "max-customer-devices": "You have reached maximum devices ({{value}}) allowed by your customer subscription!",
                        "max-provider-integrations": "You have reached maximum integrations ({{value}}) allowed by your provider subscription!",
                        "max-customer-integrations": "You have reached maximum integrations ({{value}}) allowed by your customer subscription!",
                        "max-customers": "You have reached maximum customers ({{value}}) allowed by your provider subscription!",
                        "max-sub-customers": "You have reached maximum Sub-Customers ({{value}}) allowed by your customer subscription!",
                        "provider-subscription-violation": "Please contact your Provider Administrator!",
                        "customer-subscription-violation": "Please contact your Customer Administrator!"
                    }
                },
                "providerSubscription": {
                    "management": "Provider Subscription Plans Management",
                    "providerSubscription": "Provider Subscription Plan",
                    "providerSubscriptions": "Provider Subscription Plans",
                },
                "customerSubscription": {
                    "management": "Customer Subscription Plans Management",
                    "customerSubscription": "Customer Subscription Plan",
                    "customerSubscriptions": "Customer Subscription Plans"
                },
                "limit": {
                    "unlimited": "Unlimited",
                    "max-gateways": "Amount of maximum allowed gateways",
                    "max-gateways-column": "Max Gateways",
                    "max-gateways-required": "Amount of maximum allowed gateways is required.",
                    "max-customers": "Amount of maximum allowed customers",
                    "max-customers-column": "Max Customers",
                    "max-customers-required": "Amount of maximum allowed customers is required.",
                    "max-applications": "Amount of maximum allowed applications",
                    "max-applications-column": "Max Applications",
                    "max-applications-required": "Amount of maximum allowed applications is required.",
                    "max-devices": "Amount of maximum allowed devices",
                    "max-devices-required": "Amount of maximum allowed devices is required.",
                    "max-integrations": "Amount of maximum allowed integrations",
                    "max-integrations-required": "Amount of maximum allowed integrations is required.",
                    "max-sub-customers": "Amount of maximum allowed Sub-Customers",
                    "max-sub-customers-column": "Max Sub-Customers",
                    "max-sub-customers-required": "Amount of maximum allowed Sub-Customers is required."
                },
                "subCustomer": {
                    "subCustomer": "Sub-Customer",
                    "subCustomers": "Sub-Customers",
                    "management": "Sub-Customers management",
                    "subCustomer-details": "Sub-Customer details",
                    "title": "Title",
                    "title-required": "Title is required.",
                    "description": "Description",
                    "copyId": "Copy sub-customer Id",
                    "idCopiedMessage": "Sub-Customer Id has been copied to clipboard",
                    "manage-users": "Manage users",
                    "manage-applications": "Manage applications",
                    "add": "Add Sub-Customer",
                    "delete": "Delete sub-customer",
                    "add-sub-customer-text": "Add new sub-customer",
                    "no-sub-customers-text": "No sub-customers found",
                    "sub-customer-details": "Sub-Customer details",
                    "search": "Search sub-customers",
                    "selected-sub-customers": "{ count, plural, 1 {1 sub-customer} other {# sub-customers} } selected",
                    "delete-sub-customer-title": "Are you sure you want to delete the sub-customer '{{title}}'?",
                    "delete-sub-customer-text": "Be careful, after the confirmation the sub-customer and all related data will become unrecoverable.",
                    "delete-sub-customers-title": "Are you sure you want to delete { count, plural, 1 {1 sub-customer} other {# sub-customers} }?",
                    "delete-sub-customers-text": "Be careful, after the confirmation all selected sub-customers will be removed and all related data will become unrecoverable.",
                    "subCustomer-not-found-text": "No Sub-Customers matching '{{entity}}' were found.",
                    "target-subCustomer-required-text": "Target Sub-Customer is required.",
                    "subCustomer-required": "Sub-Customer is required.",
                    "devices-count": "#of Devices",
                    "number-of-devices": "Number of devices"
                },
                "timeinterval": {
                    "seconds-interval": "{ seconds, plural, 1 {1 second} other {# seconds} }",
                    "minutes-interval": "{ minutes, plural, 1 {1 minute} other {# minutes} }",
                    "hours-interval": "{ hours, plural, 1 {1 hour} other {# hours} }",
                    "days-interval": "{ days, plural, 1 {1 day} other {# days} }",
                    "days": "Days",
                    "hours": "Hours",
                    "minutes": "Minutes",
                    "seconds": "Seconds",
                    "advanced": "Advanced"
                },
                "timewindow": {
                    "days": "{ days, plural, 1 { day } other {# days } }",
                    "hours": "{ hours, plural, 0 { hour } 1 {1 hour } other {# hours } }",
                    "minutes": "{ minutes, plural, 0 { minute } 1 {1 minute } other {# minutes } }",
                    "seconds": "{ seconds, plural, 0 { second } 1 {1 second } other {# seconds } }",
                    "realtime": "Realtime",
                    "history": "History",
                    "last-prefix": "last",
                    "period": "from {{ startTime }} to {{ endTime }}",
                    "edit": "Edit timewindow",
                    "date-range": "Date range",
                    "last": "Last",
                    "time-period": "Time period"
                },
                "user": {
                    "user": "User",
                    "users": "Users",
                    "management": "Users management",
                    "system-users": "System Users",
                    "provider-users": "Provider Users",
                    "customer-users": "Customer Users",
                    "sub-customer-users": "Sub-Customer Users",
                    "entity-users": "{{title}}: Users",
                    "sys-admin": "System administrator",
                    "sys-user": "System user",
                    "provider-admin": "Provider administrator",
                    "provider-user": "Provider user",
                    "customer-admin": "Customer administrator",
                    "customer-user": "Customer user",
                    "sub-customer-admin": "Sub-Customer administrator",
                    "sub-customer-user": "Sub-Customer user",
                    "anonymous": "Anonymous",
                    "add": "Add User",
                    "delete": "Delete user",
                    "add-user-text": "Add new user",
                    "no-users-text": "No users found",
                    "user-details": "User details",
                    "search": "Search users",
                    "selected-users": "{ count, plural, 1 {1 user} other {# users} } selected",
                    "delete-user-title": "Are you sure you want to delete the user '{{userEmail}}'?",
                    "delete-user-text": "Be careful, after the confirmation the user and all related data will become unrecoverable.",
                    "delete-users-title": "Are you sure you want to delete { count, plural, 1 {1 user} other {# users} }?",
                    "delete-users-text": "Be careful, after the confirmation all selected users will be removed and all related data will become unrecoverable.",
                    "activation-email-sent-message": "Activation email was successfully sent!",
                    "resend-activation": "Resend activation",
                    "email": "Email",
                    "email-required": "Email is required.",
                    "invalid-email-format": "Invalid email format.",
                    "first-name": "First Name",
                    "last-name": "Last Name",
                    "description": "Description",
                    "default-dashboard": "Default dashboard",
                    "always-fullscreen": "Always fullscreen",
                    "select-user": "Select user",
                    "no-users-matching": "No users matching '{{entity}}' were found.",
                    "user-required": "User is required",
                    "activation-method": "Activation method",
                    "display-activation-link": "Display activation link",
                    "send-activation-mail": "Send activation mail",
                    "activation-link": "User activation link",
                    "activation-link-text": "In order to activate user use the following <a href='{{activationLink}}' target='_blank'>activation link</a> :",
                    "copy-activation-link": "Copy activation link",
                    "activation-link-copied-message": "User activation link has been copied to clipboard",
                    "role": "Role",
                    "role-required": "Role is required."
                },
                "value": {
                    "type": "Value type",
                    "string": "String",
                    "string-value": "String value",
                    "integer": "Integer",
                    "integer-value": "Integer value",
                    "invalid-integer-value": "Invalid integer value",
                    "double": "Double",
                    "double-value": "Double value",
                    "boolean": "Boolean",
                    "boolean-value": "Boolean value",
                    "false": "False",
                    "true": "True"
                },
                "software": {
                    "management": "SW Management",
                    "ver-type": "SW versions type",
                    "ver-type-short": "Short List",
                    "ver-type-full": "Full List",
                    "read-versions": "Read Versions",
                    "component": "Component",
                    "version": "Version",
                    "current-version": "Current Version",
                    "new-version": "New Version",
                    "software-versions": "Software versions",
                    "upgradable-software": "Upgradable software",
                    "installable-software": "Installable software",
                    "selected-upgradable": "{ count, plural, 1 {1 upgradable package} other {# upgradable packages} } selected",
                    "selected-installable": "{ count, plural, 1 {1 installable package} other {# installable packages} } selected",
                    "search-components": "Search components",
                    "no-components-prompt": "No components found",
                    "no-upgradable-prompt": "No packages available for upgrading",
                    "no-installable-prompt": "No packages available for installation",
                    "index": "#",
                    "bsp-status": "Bsp Status",
                    "read-upgradable": "Read Upgradable",
                    "read-installable": "Read Installable",
                    "install-all": "Install All",
                    "install-selected": "Install Selected",
                    "upgrade-all": "Upgrade All",
                    "upgrade-selected": "Upgrade Selected",
                    "upgrade-bsp": "Upgrade BSP",
                    "special-packages-prompt": "Special packages detected, bulk upgrade/install operations disabled",
                    "bsp-status-success": "BSP Upgrade Succeeded",
                    "bsp-status-upgrade-busy": "BSP Upgrade Busy",
                    "bsp-status-bsp-upgrade-busy": "BSP Upgrade in progress. Do not turn off your board. The board may reboot several times",
                    "bsp-status-bsp-status-never-performed": "BSP Status Never Performed",
                    "bsp-status-bsp-latest": "BSP Latest",
                    "bsp-status-bsp-upgrade-error": "BSP Upgrade Error",
                    "bsp-status-break-lock": "BSP Break Lock",
                    "bsp-status-unknown": "Unknown BSP Status: {{bspStatus}}",
                    "upgrade-status": "Upgrade status: {{upgradeStatus}}",
                    "upgrade-status-success": "Software upgrade succeeded",
                    "upgrade-status-could-not-set-default-destination": "Couldn't set default destination",
                    "upgrade-status-error-parsing-config-file": "Error parsing config file",
                    "upgrade-status-could-not-obtain-temporary-directory": "Couldn't obtain temporary directory",
                    "upgrade-status-could-not-obtain-administrative-lock": "Couldn't obtain administrative lock",
                    "upgrade-status-unsatisfied-dependencies": "Unsatisfied dependencies",
                    "upgrade-status-is-essential": "Is essential",
                    "upgrade-status-has-dependents": "Has dependents",
                    "upgrade-status-has-no-candidate": "Has no candidate",
                    "upgrade-status-package-has-no-available-architecture": "Has no available architecture",
                    "upgrade-status-not-trusted": "Not trusted",
                    "upgrade-status-download-error": "Download error",
                    "upgrade-status-conflicts": "Conflicts",
                    "upgrade-status-already-installed": "Already installed",
                    "upgrade-status-dependencies": "Dependencies",
                    "upgrade-status-no-downgrade": "No downgrade",
                    "upgrade-status-out-of-space": "Out of space",
                    "upgrade-status-bad-signature": "Bad signature",
                    "upgrade-status-md5-error": "MD5 error",
                    "upgrade-status-internal-error": "Internal error",
                    "upgrade-status-unknown-error": "Unknown error",
                    "upgrade-status-tt-upgrade-busy": "Upgrade busy",
                    "upgrade-status-tt-bsp-upgrade-busy": "BSP Upgrade in progress. Do not turn off your board. The board may reboot several times",
                    "upgrade-status-tt-bsp-status-never-performed": "BSP status never performed",
                    "upgrade-status-tt-bsp-latest": "BSP latest",
                    "upgrade-status-tt-bsp-upgrade-error": "BSP upgrade error",
                    "upgrade-status-tt-general-upgrade-failure": "General upgrade failure",
                    "upgrade-status-start-upgrade": "Start upgrade",
                    "upgrade-status-unknown": "Unknown upgrade status: {{upgradeStatus}}",
                    "install-status": "Install status: {{installStatus}}",
                    "install-status-success": "Install status succeeded",
                    "install-status-could-not-set-default-destination": "Couldn't set default destination",
                    "install-status-error-parsing-config-file": "Error parsing config file",
                    "install-status-could-not-obtain-temporary-directory": "Couldn't obtain temporary directory",
                    "install-status-could-not-obtain-administrative-lock": "Couldn't obtain administrative lock",
                    "install-status-unsatisfied-dependencies": "Unsatisfied dependencies",
                    "install-status-is-essential": "Is essential",
                    "install-status-has-dependents": "Has dependents",
                    "install-status-has-no-candidate": "Has no candidate",
                    "install-status-package-has-no-available-architecture": "Has no available architecture",
                    "install-status-not-trusted": "Not trusted",
                    "install-status-download-error": "Download error",
                    "install-status-conflicts": "Conflicts",
                    "install-status-already-installed": "Already installed",
                    "install-status-dependencies": "Dependencies",
                    "install-status-no-downgrade": "No downgrade",
                    "install-status-out-of-space": "Out of space",
                    "install-status-bad-signature": "Bad signature",
                    "install-status-md5-error": "MD5 error",
                    "install-status-internal-error": "Internal error",
                    "install-status-unknown-error": "Unknown error",
                    "install-status-tt-install-busy": "Install busy",
                    "install-status-tt-general-install-failure": "General install failure",
                    "install-status-start-install": "Start install",
                    "install-status-unknown": "Unknown install status: {{installStatus}}",
                },
                "wireless-modem": {
                    "wireless-modem": "Wireless Modem",
                    "device-information": "Device Information",
                    "home-network": "Home Network",
                    "rf-information": "RF Information",
                    "active-profile-parameters": "Active Profile Parameters",
                    "call-statistics": "Call Statistics",
                    "apn": "APN",
                    "apn-new": "New APN",
                    "apn-add": "Add new APN",
                    "apn-update-set-as-active": "Update/Set as active APN",
                    "apn-delete": "Delete APN",
                    "apn-no-sim-inserted": "No SIM inserted, skipping APN verification",
                    "fw-dialog-title": "Wireless modem firmware",
                    "fw-local": "Local",
                    "fw-upload-and-install": "Upload and install",
                    "fw-remote": "Remote",
                    "fw-remote-url": "Firmware URL",
                    "fw-remote-username": "Username (optional)",
                    "fw-remote-password": "Password (optional)",
                    "fw-wipe-directory": "Wipe upload directory",
                    "fw-upgrade-modem": "Upgrade modem",
                    "fw-upload-file": "Upload file",
                    "fw-update-alert": "Updating the modem firmware, this may take a while"
                },
                "device-information": {
                    "manufacturer": "Manufacturer",
                    "model-id": "Model Id",
                    "fw-revisions": "Firmware Revisions",
                    "boot-revisions": "Boot Revisions",
                    "pri-revisions": "PRI Revisions",
                    "prl-version": "PRL Version",
                    "prl-preference": "PRL Preference",
                    "imsi": "IMSI",
                    "esn-number": "ESN Number",
                    "imei-number": "IMEI Number",
                    "meid-number": "MEID Number",
                    "hw-revision": "Hardware Revision",
                    "device-state": "Device State",
                    "public-i-p-addr": "Public IP",
                    "public-phone-nr": "Phone Number",
                    "lo": "Interface lo",
                    "sit0": "Interface sit0",
                    "eth0": "Interface eth0",
                    "eth1": "Interface eth1",
                    "wwan0": "Interface wwan0",
                    "wwan1": "Interface wwan1"
                },
                "home-network": {
                    "home-network": "Home Network",
                    "roaming-status": "Roaming Status",
                    "data-capabilities": "Data Capabilities",
                    "session-state": "Session State",
                    "data-bearer": "Data Bearer",
                    "dormancy-status": "Dormancy Status",
                    "lu-reject-cause": "LU Reject Cause"
                },
                "rf-information": {
                    "radio-interface": "Radio Interface",
                    "active-band-class": "Active Band Class",
                    "active-channel": "Active Channel",
                    "signal-strength": "Signal Strength",
                    "ecio": "ECIO",
                    "io": "IO",
                    "sinr": "SINR",
                    "rsrq": "RSRQ"
                },
                "active-profile-parameters": {
                    "pdp-type": "PDP Type",
                    "authentication": "Authentication",
                    "profile-name": "Profile Name",
                    "apn-name": "APN Name",
                    "user-name": "User Name",
                    "ip-address": "IP Address",
                    "primary-d-n-s": "Primary DNS",
                    "secondary-d-n-s": "Secondary DNS"
                },
                "call-statistics": {
                    "call-status": "Call Status",
                    "bytes-transferred": "Bytes Transferred",
                    "bytes-received": "Bytes Received",
                    "current-tx-rate": "Current TX Rate",
                    "current-rx-rate": "Current RX Rate",
                    "max-tx-rate": "MAX TX Rate",
                    "max-rx-rate": "MAX RX Rate"
                },
                "wan": {
                    "wan": "WAN",
                    "connectivity-types": "Connectivity Types",
                    "type": "Type",
                    "speed": "Speed, Mbit/s",
                    "bandwidth-usage": "Bandwidth usage, %",
                    "preferred": "Preferred",
                    "set-preferred": "Set as preferred",
                    "fallback": "Fallback",
                    "set-fallback": "Set as fallback",
                    "no-connectivity-types-prompt": "No connectivity types found",
                    "update-wan-info": "Update WAN info",
                    "preferred-ping-ip-title": "Preferred ping IP address",
                    "set-preferred-ping-ip": "Set preferred ping IP",
                    "set-preferred-fallback-interfaces": "Set preferred and fallback"
                },
                "file-transfer": {
                    "file-transfer": "File transfer",
                    "browse": "Browse",
                    "selected-file": "Selected file",
                    "decompress": "Decompress",
                    "upload": "Upload file",
                    "file-was-uploaded": "File was uploaded",
                    "archive-but-decompress-not-selected": "'Decompress' option has to be selected for archive file",
                    "not-archive-but-decompress-selected": "'Decompress' option not allowed for non-archive file.\nSupported compression formats: .zip, .tar.gz"
                },
                "bulk-provisioning": {
                    "import-data": "Import data for bulk commissioning",
                    "select-file": "Select a file",
                    "result-file": "Bulk commissioning result file",
                    "no-file-selected": "No file for commissioning selected",
                    "gw-id-column-description": "Value from column 'GW ID' in the file will be used to set a gateway ID",
                    "device-id-column-description": "Value from column 'DEVEUI' in the file will be used to set a device EUI",
                    "configure-name": "Add the column names and delimiters (press 'Enter' key after column name or delimiter typed)",
                    "name": "Column value as name",
                    "start-provisioning": "Start commissioning",
                    "add-columns-value-to-description": "Add the column names to add the values to the description field",
                    "enable-logging-description": "Enable logging after bulk commissioning",
                    "selected-columns": "Selected columns",
                    "gw-add-location": "Add the location columns",
                    "gw-location-column": "Location column",
                    "gw-latitude-column": "Latitude column",
                    "gw-longitude-column": "Longitude column",
                    "gw-altitude-column": "Altitude column",
                    "app-eui-column": "Application EUI column",
                    "app-key-column": "Application key column",
                    "add-all-other-columns-to-description": "Add all the other column values to description",
                    "wrong-column-number": "File isn't formed properly. Row {{rowNumber}} has {{numberOfCellsInRow}} cells, but table heading has {{numberOfCellsInHeader}} cells",
                    "result": "{{count}} {{entityType}} has been created"
                },
                "language": {
                    "language": "Language",
                    "en_US": "English"
                },
                "custom": {}
            }
        }
    ).name;



// WEBPACK FOOTER //
// ./src/app/locale/locale.constant.js